import { render, staticRenderFns } from "./DiagramsTab.vue?vue&type=template&id=1743f521&scoped=true&"
import script from "./DiagramsTab.vue?vue&type=script&lang=ts&"
export * from "./DiagramsTab.vue?vue&type=script&lang=ts&"
import style0 from "./DiagramsTab.vue?vue&type=style&index=0&id=1743f521&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1743f521",
  null
  
)

export default component.exports